var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-chart',{attrs:{"charts":_vm.charts}})
}
var staticRenderFns = []

export { render, staticRenderFns }